var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.deliverableDetail,
          expression: "deliverableDetail"
        }
      ],
      staticClass: "edit-deliverable-modal",
      class:
        !_vm.userAbilities.editMediaCall ||
        _vm.deliverableDetail.permissions.viewOnly
          ? "read-only"
          : ""
    },
    [
      _c(
        "div",
        { staticClass: "departments__wrapper" },
        [
          !_vm.canChangeDeliverableType()
            ? _c("div", { staticClass: "data-items department-title" }, [
                _c("span", [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.deliverableTypeTitle(
                          _vm.deliverableDetail.deliverable_template_id
                        )
                      ) +
                      "\n        "
                  )
                ])
              ])
            : _c(
                "div",
                {
                  staticClass:
                    "data-items department-title deliverable-type-link",
                  attrs: { "data-toggle": "dropdown" }
                },
                [
                  _c("span", [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.deliverableTypeTitle(
                            _vm.deliverableDetail.deliverable_template_id
                          )
                        ) +
                        "\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dropdown-menu",
                      staticStyle: { "text-transform": "none" }
                    },
                    _vm._l(_vm.deliverableTypes, function(type, i) {
                      return _c(
                        "a",
                        {
                          key: i,
                          staticClass: "dropdown-item",
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.changeDeliverableType(
                                _vm.deliverableDetail,
                                type
                              )
                            }
                          }
                        },
                        [_vm._v(_vm._s(type.name))]
                      )
                    }),
                    0
                  )
                ]
              ),
          _vm._v(" "),
          _vm.isMobile() && _vm.showDepartment()
            ? _c("DeliverableDepartments", {
                attrs: { deliverable: _vm.deliverableDetail }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("DeliverableProjects", {
            attrs: { deliverable: _vm.deliverableDetail }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.isMobile()
        ? _c("label", { staticClass: "form-group w-100 sticky__delv__title" }, [
            _c(
              "h1",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.editTitle,
                    expression: "!editTitle"
                  }
                ],
                staticClass:
                  "exclude-outside-click edit-d-title deliverable-title",
                on: { click: _vm.activateTitleField }
              },
              [_vm._v(_vm._s(_vm.deliverableDetail.title || "Click to set..."))]
            ),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "click-outside",
                  rawName: "v-click-outside",
                  value: _vm.outside,
                  expression: "outside"
                },
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.editTitle,
                  expression: "editTitle"
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.deliverableDetail.title,
                  expression: "deliverableDetail.title"
                }
              ],
              ref: "deliverableTitle",
              staticClass:
                "form-control mb-3 title-field exclude-outside-click h1",
              attrs: {
                type: "text",
                placeholder: _vm.getDeliverableTitlePlaceholder
              },
              domProps: { value: _vm.deliverableDetail.title },
              on: {
                change: _vm.updateDeliverableTitle,
                blur: function($event) {
                  _vm.editTitle = false
                },
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.deliverableDetail, "title", $event.target.value)
                }
              }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-5" },
          [
            !_vm.isMobile() && _vm.showDepartment()
              ? _c("DeliverableDepartments", {
                  attrs: { deliverable: _vm.deliverableDetail }
                })
              : _vm._e(),
            _vm._v(" "),
            !_vm.isMobile()
              ? _c("label", { staticClass: "form-group w-100" }, [
                  _c(
                    "h1",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.editTitle,
                          expression: "!editTitle"
                        }
                      ],
                      staticClass:
                        "exclude-outside-click edit-d-title deliverable-title",
                      on: { click: _vm.activateTitleField }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.deliverableDetail.title || "Click to set...")
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "click-outside",
                        rawName: "v-click-outside",
                        value: _vm.outside,
                        expression: "outside"
                      },
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.editTitle,
                        expression: "editTitle"
                      },
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.deliverableDetail.title,
                        expression: "deliverableDetail.title"
                      }
                    ],
                    ref: "deliverableTitle",
                    staticClass:
                      "form-control mb-3 title-field exclude-outside-click h1",
                    attrs: {
                      type: "text",
                      placeholder: _vm.getDeliverableTitlePlaceholder
                    },
                    domProps: { value: _vm.deliverableDetail.title },
                    on: {
                      change: _vm.updateDeliverableTitle,
                      blur: function($event) {
                        _vm.editTitle = false
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.deliverableDetail,
                          "title",
                          $event.target.value
                        )
                      }
                    }
                  })
                ])
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-7" }, [
          _c("div", { staticClass: "form-group" }, [
            _c(
              "div",
              { staticClass: "tags__wrapper" },
              [
                _c("DeliverableListTags", {
                  attrs: { deliverable: _vm.deliverableDetail }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.relatedTags.length
              ? _c(
                  "div",
                  { staticClass: "trending-tags" },
                  [
                    _c("label", [_vm._v("Trending tags:")]),
                    _vm._v(" "),
                    _vm._l(_vm.relatedTags, function(relatedTag, index) {
                      return _c(
                        "a",
                        {
                          key: "relate-tag" + index,
                          staticClass: "badge badge-success ml-2",
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.setTag(relatedTag)
                            }
                          }
                        },
                        [_vm._v(_vm._s(relatedTag.name))]
                      )
                    })
                  ],
                  2
                )
              : _vm._e()
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-12" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-8" }, [
              _c("div", { staticClass: "row no-gutters" }, [
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  _vm._l(
                    _vm._.filter(_vm.deliverableDetail.customFields, {
                      field_key: "questions"
                    }),
                    function(field, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "field-box" },
                        [
                          _c("DeliverableCustomFields", {
                            attrs: {
                              deliverable: _vm.deliverableDetail,
                              customField: field
                            }
                          })
                        ],
                        1
                      )
                    }
                  ),
                  0
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  _vm._l(
                    _vm._.filter(_vm.deliverableDetail.customFields, {
                      field_key: "responses"
                    }),
                    function(field, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "field-box" },
                        [
                          _c("DeliverableCustomFields", {
                            attrs: {
                              deliverable: _vm.deliverableDetail,
                              customField: field
                            }
                          })
                        ],
                        1
                      )
                    }
                  ),
                  0
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  _vm._l(
                    _vm._.filter(_vm.deliverableDetail.customFields, {
                      field_key: "notes_research"
                    }),
                    function(field, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "field-box" },
                        [
                          _c("DeliverableCustomFields", {
                            attrs: {
                              deliverable: _vm.deliverableDetail,
                              customField: field
                            }
                          })
                        ],
                        1
                      )
                    }
                  ),
                  0
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-4" }, [
              _c("div", { staticClass: "row no-gutters" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("div", { staticClass: "row no-gutters" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      _vm._l(
                        _vm._.filter(_vm.deliverableDetail.customFields, {
                          field_key: "priority"
                        }),
                        function(field, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "field-box" },
                            [
                              _c("DeliverableCustomFields", {
                                attrs: {
                                  deliverable: _vm.deliverableDetail,
                                  customField: field
                                }
                              })
                            ],
                            1
                          )
                        }
                      ),
                      0
                    ),
                    _vm._v(" "),
                    _vm.hasContactFields()
                      ? _c(
                          "div",
                          { staticClass: "col-md-12" },
                          [
                            _c(
                              "b-tabs",
                              {
                                staticClass: "field-tabs",
                                attrs: {
                                  "content-class": "field-tab-content",
                                  fill: ""
                                }
                              },
                              [
                                _c(
                                  "b-tab",
                                  {
                                    staticClass: "field-tab-research field-box",
                                    attrs: { active: "", title: "Contact" }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "add-contact-wrapper" },
                                      [
                                        _c(
                                          "button",
                                          {
                                            directives: [
                                              {
                                                name: "b-tooltip",
                                                rawName: "v-b-tooltip.hover",
                                                modifiers: { hover: true }
                                              }
                                            ],
                                            staticClass:
                                              "add-contact-button exclude-outside-click d-inline-block",
                                            attrs: {
                                              title: "Add spokesperson"
                                            },
                                            on: {
                                              click: _vm.showAddSpokesperson
                                            }
                                          },
                                          [_vm._v("Spokesperson")]
                                        ),
                                        _vm._v(" "),
                                        _c("plus-button", {
                                          on: { click: _vm.showAddSpokesperson }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.addSpokespersonFlag,
                                                expression:
                                                  "addSpokespersonFlag"
                                              },
                                              {
                                                name: "click-outside",
                                                rawName: "v-click-outside",
                                                value: _vm.outside,
                                                expression: "outside"
                                              }
                                            ],
                                            staticClass: "custom-multiselect"
                                          },
                                          [
                                            _c("autocomplete", {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.addSpokespersonFlag,
                                                  expression:
                                                    "addSpokespersonFlag"
                                                }
                                              ],
                                              ref: "searchSpokesperson",
                                              staticClass: "multiselect",
                                              attrs: {
                                                "debounce-time": 500,
                                                search:
                                                  _vm.onSpokespersonSearch,
                                                placeholder:
                                                  "Start typing to select spokesperson",
                                                "aria-label":
                                                  "Start typing to select spokesperson",
                                                "auto-select": ""
                                              },
                                              on: {
                                                focus: function($event) {
                                                  return _vm.onSpokespersonSearch(
                                                    false
                                                  )
                                                },
                                                submit: _vm.onSpokespersonSelect
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "result",
                                                    fn: function(ref) {
                                                      var result = ref.result
                                                      var props = ref.props
                                                      return [
                                                        result.id == null
                                                          ? _c(
                                                              "li",
                                                              _vm._b(
                                                                {
                                                                  staticClass:
                                                                    "autocomplete-result contact-result multiselect__element"
                                                                },
                                                                "li",
                                                                props,
                                                                false
                                                              ),
                                                              [
                                                                _c("div", {
                                                                  staticClass:
                                                                    "option_add",
                                                                  domProps: {
                                                                    innerHTML: _vm._s(
                                                                      result.label
                                                                    )
                                                                  }
                                                                })
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        result.id
                                                          ? _c(
                                                              "li",
                                                              _vm._b(
                                                                {
                                                                  staticClass:
                                                                    "autocomplete-result contact-result multiselect__element"
                                                                },
                                                                "li",
                                                                props,
                                                                false
                                                              ),
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "option__desc"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "option__name exclude-outside-click"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            result.first_name
                                                                          ) +
                                                                            " " +
                                                                            _vm._s(
                                                                              result.last_name
                                                                            )
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "option__company exclude-outside-click"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            result.company_name
                                                                          )
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "option__phone exclude-outside-click"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            result.phone
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                false,
                                                985483221
                                              )
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm._.filter(
                                            _vm.deliverableDetail.customFields,
                                            { field_key: "spokesperson" }
                                          ),
                                          function(contact, index) {
                                            return contact.value
                                              ? _c(
                                                  "div",
                                                  {
                                                    key:
                                                      "spokesperson-" + index,
                                                    staticClass: "contact-box"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "contact-box__name"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                              " +
                                                            _vm._s(
                                                              contact
                                                                .contactData
                                                                .name
                                                            ) +
                                                            "\n                              "
                                                        ),
                                                        !(
                                                          !_vm.userAbilities
                                                            .editMediaCall ||
                                                          _vm.deliverableDetail
                                                            .permissions
                                                            .viewOnly
                                                        )
                                                          ? _c(
                                                              "a",
                                                              {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "b-tooltip",
                                                                    rawName:
                                                                      "v-b-tooltip.hover",
                                                                    modifiers: {
                                                                      hover: true
                                                                    }
                                                                  }
                                                                ],
                                                                staticClass:
                                                                  "edit-contact-btn",
                                                                attrs: {
                                                                  title:
                                                                    "Edit spokesperson",
                                                                  href: "#"
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    $event.preventDefault()
                                                                    return _vm.updateContact(
                                                                      contact.contactData,
                                                                      "spokesperson"
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "fas fa-edit"
                                                                })
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    contact.contactData.position
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "contact-box__position"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                contact
                                                                  .contactData
                                                                  .position
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    contact.contactData
                                                      .company_name
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "contact-box__company_name"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                contact
                                                                  .contactData
                                                                  .company_name
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    contact.contactData.phone
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "contact-box__phone"
                                                          },
                                                          [
                                                            _c(
                                                              "a",
                                                              {
                                                                attrs: {
                                                                  href: _vm.Format.hrefPhone(
                                                                    contact.phone
                                                                  )
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "T: " +
                                                                    _vm._s(
                                                                      contact.phone
                                                                    )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    contact.contactData
                                                      .cell_phone
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "contact-box__cell_phone"
                                                          },
                                                          [
                                                            _c(
                                                              "a",
                                                              {
                                                                attrs: {
                                                                  href: _vm.Format.hrefPhone(
                                                                    contact.cell_phone
                                                                  )
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "M: " +
                                                                    _vm._s(
                                                                      contact.cell_phone
                                                                    )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    contact.contactData.fax
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "contact-box__fax"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "F:" +
                                                                _vm._s(
                                                                  contact
                                                                    .contactData
                                                                    .fax
                                                                )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    contact.contactData
                                                      .email_address
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "contact-box__email"
                                                          },
                                                          [
                                                            _c(
                                                              "a",
                                                              {
                                                                attrs: {
                                                                  href: _vm.Format.hrefEmail(
                                                                    contact.email_address
                                                                  )
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    contact.email_address
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    contact.contactData.address
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "contact-box__address"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                contact
                                                                  .contactData
                                                                  .address
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    contact.contactData.city
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "contact-box__city"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                contact
                                                                  .contactData
                                                                  .city
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    contact.contactData.province
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "contact-box__province"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                contact
                                                                  .contactData
                                                                  .province
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    contact.contactData
                                                      .country_id
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "contact-box__country_id"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                contact
                                                                  .contactData
                                                                  .country_id
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    contact.contactData
                                                      .postal_code
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "contact-box__postal_code"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                contact
                                                                  .contactData
                                                                  .postal_code
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    contact.contactData.region
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "contact-box__region"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                contact
                                                                  .contactData
                                                                  .region
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    contact.contactData.notes
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "contact-box__notes"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                contact
                                                                  .contactData
                                                                  .notes
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              : _vm._e()
                                          }
                                        )
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "add-contact-wrapper" },
                                      [
                                        _c(
                                          "button",
                                          {
                                            directives: [
                                              {
                                                name: "b-tooltip",
                                                rawName: "v-b-tooltip.hover",
                                                modifiers: { hover: true }
                                              }
                                            ],
                                            staticClass:
                                              "add-contact-button exclude-outside-click d-inline-block",
                                            attrs: { title: "Add contact" },
                                            on: { click: _vm.showAddWho }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.deliverableContactsLabel(
                                                  _vm.deliverableDetail
                                                    .deliverable_template_id
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("plus-button", {
                                          on: { click: _vm.showAddWho }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.addWhoFlag,
                                                expression: "addWhoFlag"
                                              },
                                              {
                                                name: "click-outside",
                                                rawName: "v-click-outside",
                                                value: _vm.outside,
                                                expression: "outside"
                                              }
                                            ],
                                            staticClass: "custom-multiselect"
                                          },
                                          [
                                            _c("autocomplete", {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: _vm.addWhoFlag,
                                                  expression: "addWhoFlag"
                                                }
                                              ],
                                              ref: "searchWho",
                                              staticClass: "multiselect",
                                              attrs: {
                                                "debounce-time": 500,
                                                search: _vm.onWhoSearch,
                                                placeholder:
                                                  "Start typing to select outlet / contact",
                                                "aria-label":
                                                  "Start typing to select outlet / contact",
                                                "auto-select": ""
                                              },
                                              on: { submit: _vm.onWhoSelect },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "result",
                                                    fn: function(ref) {
                                                      var result = ref.result
                                                      var props = ref.props
                                                      return [
                                                        result.id == null
                                                          ? _c(
                                                              "li",
                                                              _vm._b(
                                                                {
                                                                  staticClass:
                                                                    "autocomplete-result contact-result multiselect__element"
                                                                },
                                                                "li",
                                                                props,
                                                                false
                                                              ),
                                                              [
                                                                _c("div", {
                                                                  staticClass:
                                                                    "option_add",
                                                                  domProps: {
                                                                    innerHTML: _vm._s(
                                                                      result.label
                                                                    )
                                                                  }
                                                                })
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        result.id
                                                          ? _c(
                                                              "li",
                                                              _vm._b(
                                                                {
                                                                  staticClass:
                                                                    "autocomplete-result contact-result multiselect__element"
                                                                },
                                                                "li",
                                                                props,
                                                                false
                                                              ),
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "option__desc"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "option__name exclude-outside-click"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            result.first_name
                                                                          ) +
                                                                            " " +
                                                                            _vm._s(
                                                                              result.last_name
                                                                            )
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "option__company exclude-outside-click"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            result.company_name
                                                                          )
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "option__phone exclude-outside-click"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            result.phone
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                false,
                                                985483221
                                              )
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm._.filter(
                                            _vm.deliverableDetail.customFields,
                                            { field_key: "who" }
                                          ),
                                          function(contact, index) {
                                            return contact.value
                                              ? _c(
                                                  "div",
                                                  {
                                                    key: "who-" + index,
                                                    staticClass: "contact-box"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "contact-box__name"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                              " +
                                                            _vm._s(
                                                              contact
                                                                .contactData
                                                                .name
                                                            ) +
                                                            "\n                              "
                                                        ),
                                                        !(
                                                          !_vm.userAbilities
                                                            .editMediaCall ||
                                                          _vm.deliverableDetail
                                                            .permissions
                                                            .viewOnly
                                                        )
                                                          ? _c(
                                                              "a",
                                                              {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "b-tooltip",
                                                                    rawName:
                                                                      "v-b-tooltip.hover",
                                                                    modifiers: {
                                                                      hover: true
                                                                    }
                                                                  }
                                                                ],
                                                                staticClass:
                                                                  "edit-contact-btn",
                                                                attrs: {
                                                                  title:
                                                                    "Edit contact",
                                                                  href: "#"
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    $event.preventDefault()
                                                                    return _vm.updateContact(
                                                                      contact.contactData,
                                                                      "who"
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "fas fa-edit"
                                                                })
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    contact.contactData.position
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "contact-box__position"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                contact
                                                                  .contactData
                                                                  .position
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    contact.contactData
                                                      .company_name
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "contact-box__company_name"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                contact
                                                                  .contactData
                                                                  .company_name
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    contact.contactData.phone
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "contact-box__phone"
                                                          },
                                                          [
                                                            _c(
                                                              "a",
                                                              {
                                                                attrs: {
                                                                  href: _vm.Format.hrefPhone(
                                                                    contact.phone
                                                                  )
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "T: " +
                                                                    _vm._s(
                                                                      contact.phone
                                                                    )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    contact.contactData
                                                      .cell_phone
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "contact-box__cell_phone"
                                                          },
                                                          [
                                                            _c(
                                                              "a",
                                                              {
                                                                attrs: {
                                                                  href: _vm.Format.hrefPhone(
                                                                    contact.cell_phone
                                                                  )
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "M: " +
                                                                    _vm._s(
                                                                      contact.cell_phone
                                                                    )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    contact.contactData.fax
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "contact-box__fax"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "F:" +
                                                                _vm._s(
                                                                  contact
                                                                    .contactData
                                                                    .fax
                                                                )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    contact.contactData
                                                      .email_address
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "contact-box__email"
                                                          },
                                                          [
                                                            _c(
                                                              "a",
                                                              {
                                                                attrs: {
                                                                  href: _vm.Format.hrefEmail(
                                                                    contact.email_address
                                                                  )
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    contact.email_address
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    contact.contactData.address
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "contact-box__address"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                contact
                                                                  .contactData
                                                                  .address
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    contact.contactData.city
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "contact-box__city"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                contact
                                                                  .contactData
                                                                  .city
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    contact.contactData.province
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "contact-box__province"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                contact
                                                                  .contactData
                                                                  .province
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    contact.contactData
                                                      .country_id
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "contact-box__country_id"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                contact
                                                                  .contactData
                                                                  .country_id
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    contact.contactData
                                                      .postal_code
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "contact-box__postal_code"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                contact
                                                                  .contactData
                                                                  .postal_code
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    contact.contactData.region
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "contact-box__region"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                contact
                                                                  .contactData
                                                                  .region
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    contact.contactData.notes
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "contact-box__notes"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                contact
                                                                  .contactData
                                                                  .notes
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              : _vm._e()
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-tab",
                                  {
                                    staticClass: "field-tab-chat",
                                    attrs: { title: "Chat", disabled: "" }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "dummy-chat" },
                                      [
                                        _c("img", {
                                          staticClass: "logo",
                                          attrs: {
                                            src: require("@/csmworkflow/img/dummy-chat.svg")
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("b-form-input", {
                                          staticClass: "input-new-chat-message",
                                          attrs: {
                                            type: "text",
                                            placeholder: "Enter comment..."
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      _vm._l(
                        _vm._.filter(_vm.deliverableDetail.customFields, {
                          field_key: "start_date"
                        }),
                        function(field, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "field-box" },
                            [
                              _c("DeliverableCustomFields", {
                                attrs: {
                                  deliverable: _vm.deliverableDetail,
                                  customField: field
                                }
                              })
                            ],
                            1
                          )
                        }
                      ),
                      0
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-12 field-box" }, [
                      _c("div", { staticClass: "field-box__header" }, [
                        _c(
                          "div",
                          { staticClass: "dropdown" },
                          [
                            _c(
                              "button",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover",
                                    modifiers: { hover: true }
                                  }
                                ],
                                staticClass:
                                  "add-resource-button exclude-outside-click d-inline-block",
                                attrs: {
                                  title: "Add resource",
                                  "data-toggle": "dropdown",
                                  "aria-expanded": "false",
                                  "data-reference": "parent"
                                }
                              },
                              [_vm._v("Resources")]
                            ),
                            _vm._v(" "),
                            _c("plus-button", {
                              attrs: {
                                "data-toggle": "dropdown",
                                "aria-expanded": "false",
                                "data-reference": "parent"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "dropdown-menu deliverable-resource-type-menu"
                              },
                              _vm._l(_vm.optionsForLinkType, function(type, i) {
                                return _c(
                                  "a",
                                  {
                                    key: i,
                                    staticClass: "dropdown-item",
                                    attrs: { href: "#" },
                                    on: {
                                      click: function($event) {
                                        return _vm.addResourceMenuItemClick(
                                          type.id,
                                          $event
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "link-type-icon",
                                      attrs: {
                                        src: require("@/csmworkflow/img/" +
                                          type.icon)
                                      }
                                    }),
                                    _vm._v(" " + _vm._s(type.name))
                                  ]
                                )
                              }),
                              0
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "field-box__content" },
                        _vm._l(
                          _vm._.filter(_vm.deliverableDetail.customFields, {
                            field_key: "link_url"
                          }),
                          function(resource, index) {
                            return _c(
                              "div",
                              {
                                key: "link_url-" + index,
                                staticClass: "resource-box"
                              },
                              [
                                _c("div", { staticClass: "media" }, [
                                  _c("img", {
                                    staticClass: "link-type-icon",
                                    staticStyle: { "margin-right": "3px" },
                                    attrs: {
                                      src: require("@/csmworkflow/img/" +
                                        _vm.getLinkTypeObject(
                                          _vm.customChildFieldValue(
                                            "link_type",
                                            resource.id
                                          )
                                        ).icon),
                                      draggable: "false"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "media-body" },
                                    [
                                      _c("div", {
                                        staticClass: "resource-box__url"
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: resource.value,
                                            target: "blank",
                                            id: "resource-" + index
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.openCopyLinkModal(
                                                resource.value,
                                                $event,
                                                index
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.customChildFieldValue(
                                                "link_label",
                                                resource.id
                                              ) || resource.value
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-tooltip",
                                        {
                                          attrs: {
                                            target: "resource-" + index,
                                            noninteractive: "",
                                            triggers: "manual"
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fas fa-check",
                                            staticStyle: { color: "#4C9850" }
                                          }),
                                          _vm._v(" Link Copied!")
                                        ]
                                      ),
                                      _vm._v(" "),
                                      !(
                                        !_vm.userAbilities.editMediaCall ||
                                        _vm.deliverableDetail.permissions
                                          .viewOnly
                                      )
                                        ? _c(
                                            "a",
                                            {
                                              directives: [
                                                {
                                                  name: "b-tooltip",
                                                  rawName: "v-b-tooltip.hover",
                                                  modifiers: { hover: true }
                                                }
                                              ],
                                              staticClass: "edit-resource-btn",
                                              attrs: {
                                                title: "Edit resource",
                                                href: "#"
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.editResource(
                                                    resource
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fas fa-edit"
                                              })
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.customChildFieldValue(
                                        "link_notes",
                                        resource.id
                                      )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "resource-box__notes"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.customChildFieldValue(
                                                    "link_notes",
                                                    resource.id
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          }
                        ),
                        0
                      )
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-3" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-12" },
          [
            _c(
              "div",
              { staticClass: "add-task-button-mobile" },
              [
                !(
                  !_vm.userAbilities.editMediaCall ||
                  _vm.deliverableDetail.permissions.viewOnly
                )
                  ? _c(
                      "b-button",
                      {
                        staticClass: "add-task-btn",
                        attrs: { variant: "theme" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.createTask.apply(null, arguments)
                          }
                        }
                      },
                      [
                        _vm._v("\n          Add Task\n          "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.addingTask,
                                expression: "addingTask"
                              }
                            ],
                            staticClass:
                              "ml-2 spinner-border spinner-border-sm text-primary",
                            attrs: { role: "status" }
                          },
                          [
                            _c("span", { staticClass: "sr-only" }, [
                              _vm._v("Loading...")
                            ])
                          ]
                        )
                      ]
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c("TaskFieldLabels", {
              ref: "TaskFieldLabelsRef",
              attrs: {
                fullDeliverables: _vm.deliverableDetail,
                deliverableId: _vm.deliverableDetail.deliverableId,
                deliverable: _vm.deliverableDetail,
                tasks: _vm.deliverableDetail.tasks
              }
            }),
            _vm._v(" "),
            _c("TaskFields", {
              attrs: {
                fullDeliverables: _vm.deliverableDetail,
                deliverableId: _vm.deliverableDetail.deliverableId,
                deliverable: _vm.deliverableDetail,
                tasks: _vm.deliverableDetail.tasks
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "responsive-edit-modal-controls",
          class: _vm.showModalOptions ? "open" : ""
        },
        [
          _c(
            "button",
            {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip.hover",
                  modifiers: { hover: true }
                }
              ],
              staticClass: "btn modal-more-controls",
              attrs: { title: "More options" },
              on: {
                click: function($event) {
                  _vm.showModalOptions = !_vm.showModalOptions
                }
              }
            },
            [
              _c("i", {
                staticClass: "fas",
                class: !_vm.showModalOptions
                  ? "fa-arrow-left"
                  : "fa-arrow-right"
              })
            ]
          ),
          _vm._v(" "),
          _vm.userAbilities.deleteMediaCall &&
          !_vm.deliverableDetail.permissions.viewOnly
            ? _c(
                "button",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover",
                      modifiers: { hover: true }
                    }
                  ],
                  staticClass: "btn delete-deliverable-btn",
                  attrs: { title: _vm.getDeleteDeliverableTitle },
                  on: {
                    click: function($event) {
                      return _vm.removeDeliverable(
                        _vm.deliverableDetail.deliverableId
                      )
                    }
                  }
                },
                [_c("i", { staticClass: "fas fa-trash-alt" })]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("DuplicateMediaCallBtn", {
            attrs: { deliverableId: _vm.deliverableDetail.deliverableId }
          }),
          _vm._v(" "),
          _c("FeedbackBtn"),
          _vm._v(" "),
          _c(
            "button",
            {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip.hover",
                  modifiers: { hover: true }
                }
              ],
              staticClass: "btn close-deliverable-btn",
              attrs: { title: "Close" },
              on: { click: _vm.onCloseModal }
            },
            [_c("i", { staticClass: "fas fa-times" })]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            type: "warn",
            title: "Confirm Deletion",
            "ok-title": "Yes, Delete"
          },
          on: { ok: _vm.onConfirmRemoveDeliverable },
          model: {
            value: _vm.showRemoveDeliverable,
            callback: function($$v) {
              _vm.showRemoveDeliverable = $$v
            },
            expression: "showRemoveDeliverable"
          }
        },
        [_c("p", [_vm._v("Are you sure you want to delete this deliverable?")])]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            type: "warn",
            title: "Confirm Contact Removal",
            "ok-title": "Yes, Remove"
          },
          on: { ok: _vm.onConfirmRemoveContact },
          model: {
            value: _vm.showRemoveContact,
            callback: function($$v) {
              _vm.showRemoveContact = $$v
            },
            expression: "showRemoveContact"
          }
        },
        [_c("p", [_vm._v("Are you sure you want to unassign this contact?")])]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            type: "warn",
            title: "Confirm Contact Removal",
            "ok-title": "Yes, Remove"
          },
          on: { ok: _vm.onConfirmRemoveSpokesperson },
          model: {
            value: _vm.showRemoveSpokesperson,
            callback: function($$v) {
              _vm.showRemoveSpokesperson = $$v
            },
            expression: "showRemoveSpokesperson"
          }
        },
        [
          _c("p", [
            _vm._v("Are you sure you want to unassign this spokesperson?")
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            type: "warn",
            title: "Confirm Contact Removal",
            "ok-title": "Yes, Remove"
          },
          on: { ok: _vm.onConfirmRemoveWho },
          model: {
            value: _vm.showRemoveWho,
            callback: function($$v) {
              _vm.showRemoveWho = $$v
            },
            expression: "showRemoveWho"
          }
        },
        [_c("p", [_vm._v("Are you sure you want to unassign this outlet?")])]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            "hide-footer": "",
            id: "createLinkModal",
            title: "New Resource / Link"
          },
          on: { shown: _vm.focusLinkModal }
        },
        [
          _c("CreateLinkModal", {
            ref: "refLinkModal",
            attrs: {
              "link-url": _vm.linkUrl,
              "link-label": _vm.linkLabel,
              "link-notes": _vm.linkNotes,
              "link-type": _vm.linkType
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            "hide-footer": "",
            id: "editLinkModal",
            title: "Update Resource / Link"
          },
          on: { shown: _vm.focusEditLinkModal }
        },
        [
          _c("EditLinkModal", {
            ref: "refEditLinkModal",
            attrs: {
              "link-url": _vm.linkUrl,
              "link-label": _vm.linkLabel,
              "link-notes": _vm.linkNotes,
              "link-type": _vm.linkType,
              "is-file": _vm.editLinkIsFile
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            id: "linkCopyLinkModal",
            title: "Copy Link",
            "ok-only": "",
            "ok-title": "Done"
          }
        },
        [
          _c("LinkCopyLinkModal", {
            attrs: { linkUrl: _vm.linkCopyModalValue }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }